import {DomainObject, oneOf} from 'shared/store';
import {observable, computed, action} from 'mobx';
import AttachedDocument from 'stores/documents/AttachedDocument';

class TimeTrackingReportDownload extends DomainObject {
  @observable status;
  @observable reportFile;

  @action merge(other) {
    super.merge(other, {
      status: oneOf(['pending', 'successful', 'failed']),
      reportFile: AttachedDocument
    });
  }

  @computed get isFinished() {
    return this.status === 'successful' || this.status === 'failed';
  }
}

export default TimeTrackingReportDownload;
